// Quem abre estas telas (TRI-107; o admin passa). Aplicado pelo guard de @/router/permissoes.js,
// que o menu lateral também usa.
const ROLES = ['gestor_certificados_digitais']


const breadCrumb = [
    {
        label: 'Home',
        to: 'Home'
    },
    {
        label: 'Certificados',
        to: 'CertificadoList'
    }
]

export default [
    {
        path: '/certificado',
        name: 'CertificadoList',
        component: () => import('@/views/Certificado/CertificadoListPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Certificados',
            breadcrumb: breadCrumb
        },
    },
    {
        path: '/certificado/novo',
        name: 'NovoCertificado',
        component: () => import('@/views/Certificado/NovoCertificadoPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Novo Certificado',
            breadcrumb: [
                ...breadCrumb,
                {
                    label: 'Novo Certificado',
                    to: 'NovoCertificado'
                }
            ]
        }
    },
    {
        path: '/certificado/:id/edit',
        name: 'NovoCertificadoEdit',
        component: () => import('@/views/Certificado/NovoCertificadoPage.vue'),
        meta: {
            roles: ROLES,
            title: 'Detalhes do Certificado',
            breadcrumb: [
                ...breadCrumb,
                {
                    label: 'Detalhes do Certificado',
                    to: 'NovoCertificado'
                }
            ]
        }
    },
    {
        path: '/permissoes-certificado/novo',
        name: 'NovaPermissaoCertificado',
        component: () => import('@/views/Certificado/PermissaoAcesso/PermissaoAcessoFormModal.vue'),
        meta: {
            roles: ROLES,
            title: 'Nova Permissao',
            breadcrumb: [
                ...breadCrumb,
                {
                    label: 'Novo Certificado',
                    to: 'NovoCertificado'
                }
            ]
        }
    },

];